import { render, staticRenderFns } from "./ColorSidebar.vue?vue&type=template&id=4cea4a5e&scoped=true"
import script from "./ColorSidebar.vue?vue&type=script&lang=js"
export * from "./ColorSidebar.vue?vue&type=script&lang=js"
import style0 from "./ColorSidebar.vue?vue&type=style&index=0&id=4cea4a5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea4a5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cea4a5e')) {
      api.createRecord('4cea4a5e', component.options)
    } else {
      api.reload('4cea4a5e', component.options)
    }
    module.hot.accept("./ColorSidebar.vue?vue&type=template&id=4cea4a5e&scoped=true", function () {
      api.rerender('4cea4a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Settings/ColorSidebar.vue"
export default component.exports